import request from '@/utils/request';

/**
 * 获取assess_token 和 openID
 */
export function getwxUserInfo(code, secret) {
  const url = 'datasync-dataviewsimulator/services/wechatofficial/getwxUserInfo';
  return request({
    url,
    methods: 'get',
    params: { code, secret }
  });
}
